module.exports = "/_next/static/images/f20d7e876d8ab3703081699d3568629e-card-circle.svg";